const DURATION = 780;

let scrollGen = 0;

function easeInOut(t) {
  return t < 0.5 ? 2 * t * t : 1 - 2 * (1 - t) * (1 - t);
}

export function cancelLuxuryScroll() {
  scrollGen += 1;
}

function luxuryScrollY(getY, setY, endY, duration = DURATION) {
  const start = getY();
  const distance = endY - start;
  if (Math.abs(distance) < 2) return;
  const origin = performance.now();
  const gen = ++scrollGen;

  function step(now) {
    if (gen !== scrollGen) return;
    const progress = Math.min(1, (now - origin) / duration);
    setY(start + distance * easeInOut(progress));
    if (progress < 1) requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
}

export function scrollWindowTo(y = 0) {
  luxuryScrollY(
    () => window.scrollY || window.pageYOffset,
    (value) => window.scrollTo(0, value),
    y
  );
}

export function scrollElementTo(el, y = 0) {
  if (!el) return;
  luxuryScrollY(
    () => el.scrollTop,
    (value) => {
      el.scrollTop = value;
    },
    y
  );
}

export function resetPageScroll() {
  cancelLuxuryScroll();
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  document
    .querySelectorAll(
      ".desk-frame__body, .journey-frame__body, .sidebar-frame__body, .journey-sidebar__body"
    )
    .forEach((el) => {
      el.scrollTop = 0;
    });
}

export function scrollToFooter() {
  const footer = document.getElementById("information-resources");
  if (!footer) return;
  const frame = footer.closest(".journey-frame__body, .desk-frame__body, .app-main");
  if (frame && typeof frame.scrollTop === "number" && frame.scrollHeight > frame.clientHeight + 12) {
    const y = footer.getBoundingClientRect().top - frame.getBoundingClientRect().top + frame.scrollTop - 16;
    scrollElementTo(frame, Math.max(0, y));
    return;
  }
  const start = window.scrollY || window.pageYOffset;
  const end = footer.getBoundingClientRect().top + start - 16;
  luxuryScrollY(
    () => window.scrollY || window.pageYOffset,
    (value) => window.scrollTo(0, value),
    end
  );
}
